import { render, staticRenderFns } from "./ProfitReport.vue?vue&type=template&id=20520bc7"
import script from "./ProfitReport.vue?vue&type=script&lang=js"
export * from "./ProfitReport.vue?vue&type=script&lang=js"
import style0 from "./ProfitReport.vue?vue&type=style&index=0&id=20520bc7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports